import { observable, action, runInAction } from 'mobx';
import { post, get } from '../../utils/fetch';
import { errorHandler } from '../../utils/methods';
import { backendServer } from '../../variable';

class Enteriprise {
  @observable
  EnteripriseList = []; //企业列表
  @observable
  EnteripriseDetails = []; //企业详情
  @action
  fetchEnteripriseList = async params => {
    //获取企业列表
    try {
      const response = await get(`${backendServer}/enterprise/list`, params);

      runInAction(() => {
        if (response.success) {
          this.EnteripriseList = response.data;
        } else {
          this.EnteripriseList = [];
          errorHandler(response);
        }
      });
    } catch (error) {
      errorHandler(error, '获取企业列表');
    }
  };

  @action
  fetchEnteripriseDetails = async params => {
    //获取企业详情
    try {
      if (params.id == 'new') {
        runInAction(() => {
          this.EnteripriseDetails = [];
        });
      } else {
        const response = await get(
          `${backendServer}/enterprise/detail`,
          params
        );

        if (response.success) {
          runInAction(() => {
            this.EnteripriseDetails = response.data;
          });
        } else {
          errorHandler(response);
        }
      }
    } catch (error) {
      errorHandler(error, '获取企业详情');
    }
  };

  @action
  newEnterprise = async params => {
    //新增企业
    let response;
    try {
      response = await post(`${backendServer}/enterprise/create`, params);
    } catch (error) {
      return errorHandler(error, '新增企业');
    }
    return response;
  };

  @action
  alterEnterprise = async params => {
    //修改企业
    let response;
    try {
      response = await post(`${backendServer}/enterprise/update`, params);
    } catch (error) {
      return errorHandler(error, '修改企业');
    }
    return response;
  };
}
export default new Enteriprise();



// WEBPACK FOOTER //
// ./src/stores/enterpriseStore/index.js